import { render, staticRenderFns } from "./quotaOverview.vue?vue&type=template&id=5a397728&scoped=true"
import script from "./quotaOverview.vue?vue&type=script&lang=jsx"
export * from "./quotaOverview.vue?vue&type=script&lang=jsx"
import style0 from "./quotaOverview.vue?vue&type=style&index=0&id=5a397728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a397728",
  null
  
)

export default component.exports